// Pure function: rank region rows by a chosen metric.
// Used by the "Top Markets" summary panel (issue #11).

/**
 * @typedef {object} RankedEntry
 * @property {number} rank - 1-based rank
 * @property {string} countryCode
 * @property {string} countryName
 * @property {number} value - the metric value used for ranking
 */

/**
 * Return the top N available, non-errored rows sorted by `userRatingCount`
 * descending. Rows without a rating count are excluded.
 *
 * @param {import('./normalizeApp.js').RegionRow[]} rows
 * @param {number} [n=5]
 * @returns {RankedEntry[]}
 */
export function rankByRatingCount(rows, n = 5) {
  return (Array.isArray(rows) ? rows : [])
    .filter((r) => r.available && !r.error && r.userRatingCount !== null)
    .sort((a, b) => b.userRatingCount - a.userRatingCount)
    .slice(0, n)
    .map((r, i) => ({
      rank: i + 1,
      countryCode: r.countryCode,
      countryName: r.countryName,
      value: r.userRatingCount,
    }));
}

/**
 * Return the top N available, non-errored rows sorted by `averageUserRating`
 * descending. Rows without a rating are excluded.
 *
 * @param {import('./normalizeApp.js').RegionRow[]} rows
 * @param {number} [n=5]
 * @returns {RankedEntry[]}
 */
export function rankByRating(rows, n = 5) {
  return (Array.isArray(rows) ? rows : [])
    .filter((r) => r.available && !r.error && r.averageUserRating !== null)
    .sort((a, b) => b.averageUserRating - a.averageUserRating)
    .slice(0, n)
    .map((r, i) => ({
      rank: i + 1,
      countryCode: r.countryCode,
      countryName: r.countryName,
      value: r.averageUserRating,
    }));
}
